export const CreditStatus = {
  OPEN: 1,
  SENT: 2,
};

export const CreditStatusString = {
  1: 'Open',
  2: 'Verzonden',
};